export enum MzImageResolutionName {
  Xxl = 'xxl',
  Xl = 'xl',
  L = 'l',
  M = 'm',
  S = 's',
  Xs = 'xs',
  Xxs = 'xxs',
}

const { Xxl, Xl, L, M, S, Xs, Xxs } = MzImageResolutionName;

export const MzImageResolutionNameOrdered: Array<MzImageResolutionName> = [Xxl, Xl, L, M, S, Xs, Xxs];



// WEBPACK FOOTER //
// ./src/module/Model/MzImage/MzImageResolutionName.ts